import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestKPIS(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getDashboardKpi`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getDashboardKpi`, params);
  }
}

export function requestLeadsKPIDashboardList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getLeadCount`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getLeadCount`, params);
  }
}

export function requestClientsDashboardList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getIndustryExposure`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getIndustryExposure`,
      params
    );
  }
}

export function requestTopDealsWonList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getTopDealWon`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getTopDealWon`, params);
  }
}

export function requestleadsPipelineList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getleadPipeline`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getleadPipeline`, params);
  }
}
export function requestsmartproposalPipelineList(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getProposalPipeline`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getProposalPipeline`,
      params
    );
  }
}

export function requestwinRate(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getWinRate`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getWinRate`, params);
  }
}

export function requestwinLossReport(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getWinLossReport`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getWinLossReport`, params);
  }
}

export function requestsalesPipelineBysalesRepresentative(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getSalesPipeline`);
  } else {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getSalesPipeline`, params);
  }
}
export function requestTotalAgreements(params) {
  return fetch.post(`${BASE_URL}/api/app/dashboard/totalAggrement`, params);
}

export function requestClientSeatsKPIS(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getClientAndSeats`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getClientAndSeats`,
      params
    );
  }
}

export function requestRecentClosedDeal(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getRecentClosedDeals`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getRecentClosedDeals`,
      params
    );
  }
}
